import { IRootState } from '../../../store'
import { IWasPatientImmOptionsState } from '../store/options.types'

export const getWasPatientImmobilizedOptionsSelector = (state: IRootState): IWasPatientImmOptionsState =>
  state.options.wasPatientImmobilizedOptions
